// extracted by mini-css-extract-plugin
export var boxItems = "_6m-1";
export var boxItemsLg = "_6m-2";
export var button = "_6m-7";
export var buttonHoverless = "_6m-9";
export var buttonLg = "_6m-8";
export var filterGroupBox = "_6m-0";
export var icon = "_6m-3";
export var iconSecondary = "_6m-6";
export var iconWrapper = "_6m-4";
export var iconWrapperLg = "_6m-5";
export var truncatedLabel = "_6m-a";